




import { Vue, Component, Prop } from 'vue-property-decorator';
import tuiColorPicker from 'tui-color-picker';

interface TuiColorPicker {
  create: ({ container: HTMLElement }) => TuiColorPicker;
  on: (eventName: string, callBackFunction: Function) => void;
  setColor: (defaultColorHexCode: string) => void;
}

interface Color {
  color: string;
  origin: string;
}

@Component
export default class ColorPicker extends Vue {
  @Prop({ default: '#ffffff' }) public defaultColorHexCode: string;

  public tuiColorPicker: TuiColorPicker = tuiColorPicker;
  public colorPicker!: TuiColorPicker;
  public selectColorHexCode: string = this.defaultColorHexCode;

  mounted() {
    this.init();
  }

  private init() {
    this.colorPicker = this.tuiColorPicker.create({
      container: this.$refs.colorPickerContainer,
    });

    this.colorPicker.setColor(this.defaultColorHexCode);

    this.bindEvents();
  }

  private bindEvents() {
    this.colorPicker.on('selectColor', event => this.onSelectColor(event));
  }

  private onSelectColor(colorData: Color) {
    this.selectColorHexCode = colorData.color;

    this.$emit('onSelect', this.selectColorHexCode);
  }
}
